module.exports = __webpack_public_path__ + "static/banner-mobile-28ce78632ae1b02f8dce95ab13b3da46.png";